import Icon from '../Icon';
import type { IconNode, LucideProps } from '../types';

const iconNode: IconNode = [
  ['path', { d: 'M10 22a2 2 0 0 1-2-2', key: 'i7yj1i' }],
  ['path', { d: 'M16 22h-2', key: '18d249' }],
  [
    'path',
    {
      d: 'M16 4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-5a2 2 0 0 1 2-2h5a1 1 0 0 0 1-1z',
      key: '1njgbb',
    },
  ],
  ['path', { d: 'M20 8a2 2 0 0 1 2 2', key: '1770vt' }],
  ['path', { d: 'M22 14v2', key: 'iot8ja' }],
  ['path', { d: 'M22 20a2 2 0 0 1-2 2', key: 'qj8q6g' }],
];

/**
 * @component @name SquaresSubtract
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjJhMiAyIDAgMCAxLTItMiIgLz4KICA8cGF0aCBkPSJNMTYgMjJoLTIiIC8+CiAgPHBhdGggZD0iTTE2IDRhMiAyIDAgMCAwLTItMkg0YTIgMiAwIDAgMC0yIDJ2MTBhMiAyIDAgMCAwIDIgMmgzYTEgMSAwIDAgMCAxLTF2LTVhMiAyIDAgMCAxIDItMmg1YTEgMSAwIDAgMCAxLTF6IiAvPgogIDxwYXRoIGQ9Ik0yMCA4YTIgMiAwIDAgMSAyIDIiIC8+CiAgPHBhdGggZD0iTTIyIDE0djIiIC8+CiAgPHBhdGggZD0iTTIyIDIwYTIgMiAwIDAgMS0yIDIiIC8+Cjwvc3ZnPg==) - https://lucide.dev/icons/squares-subtract
 * @see https://lucide.dev/guide/packages/lucide-solid - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SquaresSubtract = (props: LucideProps) => (
  <Icon {...props} iconNode={iconNode} name="squares-subtract" />
);

export default SquaresSubtract;
